<template>

  <!-- File Background -->
  <div
    :style="styles"
    :class="classes"
    class="file-background">

    <!-- Ratio -->
    <q-responsive
      :ratio="ratio || videoRatio"
      class="file-background__ratio"
      v-if="ratio || fileType === 'video'"/>

    <!-- Ratio -->
    <img
      :src="fileLink"
      class="file-background__ratio"
      v-else-if="fileType === 'image'"/>

    <!-- Image -->
    <div
      :style="imageStyles"
      v-if="fileType === 'image'"
      class="file-background__image"/>

    <!-- Video -->
    <video
      loop
      muted
      autoplay
      playsinline
      class="file-background__video"
      v-else-if="fileType === 'video'">

      <source
        :src="fileLink"
        type="video/mp4">

    </video>

    <!-- Placeholder -->
    <div
      v-else-if="!noPlaceholder"
      class="file-background__placeholder"/>

  </div>

</template>

<script>

  export default {
    name: 'file-background',
    props: {
      value: {
        type: Object,
        default: null,
      },
      color: {
        type: String,
        default: '',
      },
      ratio: {
        type: Number,
        default: 0,
      },
      videoRatio: {
        type: Number,
        default: 16 / 9,
      },
      contain: {
        type: Boolean,
        default: false,
      },
      noPlaceholder: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      classes() {

        return {
          contain: this.contain,
          [this.fileType]: this.fileType,
        };
      },
      styles() {

        return {
          backgroundColor: this.color,
        };
      },
      imageStyles() {

        const link = this.fileLink
          || this.placeholder;

        return {
          backgroundImage: `url('${link}')`,
        };
      },
      fileLink() {

        return this.value
          && this.getFileUrl(this.value);
      },
      fileType() {

        return this.value
          && this.value.type
            .replace(/(.+)\/.*/, '$1');
      },
    },
  };

</script>

<style lang="scss">

  $cls: file-background;

  .file-background {
    line-height: 0;
    position: relative;
    display: inline-block;

    &__ratio {
      max-width: 100%;
      max-height: 100%;
      visibility: hidden;
    }

    &__video,
    &__image,
    &__placeholder {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      position: absolute;
    }

    &__image,
    &__placeholder {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }

    &__placeholder {
      background-image: url('/images/placeholder/image.png');
    }

    &__video {
      object-fit: cover;
    }

    &.contain {

      .#{$cls}__image {
        background-size: contain;
      }

      .#{$cls}__video {
        object-fit: contain;
      }
    }
  }

</style>
